import load from "./pageLoad";
import click from "./onClick";

export const onClick = click;
export const pageLoadTags = load;
